import {MapTypesToInstances, PatEntry} from "../pattern_match";
import {ScopeChainNode} from "../analysis";
import {CompletionResult} from "@codemirror/autocomplete";
import {BaseTree} from "../model";
import {Token} from "../lexer";

export type CompletionPattern<
	T extends Readonly<Array<PatEntry>>,
	F extends (
		chain: (BaseTree | Token)[],
		innermostScope: ScopeChainNode,
		...args: MapTypesToInstances<T>
	) => CompletionResult | null,
> = {
	pat: T;
	handler: F;
};

export type CompletionPatternFrom<T extends Readonly<Array<PatEntry>>> =
	CompletionPattern<
		T,
		(
			chain: (BaseTree | Token)[],
			innermostScope: ScopeChainNode,
			...args: MapTypesToInstances<T>
		) => CompletionResult | null
	>;

export function makeCompletionPattern<
	T extends Readonly<Array<PatEntry>>,
	F extends (
		chain: (BaseTree | Token)[],
		innermostScope: ScopeChainNode,
		...args: MapTypesToInstances<T>
	) => CompletionResult | null,
>(pat: T, handler: F): CompletionPattern<T, F> {
	return {pat, handler};
}
